import React, { useCallback, useState } from 'react';
import { SCUIContent } from '../../atomic/organisms';
import { ExpenseNoteFilterDrawer } from './components/ExpenseNoteFilterDrawer';
import { ExpenseNoteDataGrid } from './components/ExpenseNoteDataGrid';
import { Box, Grid } from '@mui/material';
import { EXPNOTE } from './expenseNote.classes';
import { SCUIButton } from '../../atomic/atoms';
import SearchIcon from '@mui/icons-material/Search';
import { SCUIGeneralDrawer } from '../../atomic/molecules';
import ExpenseNoteQuery from '../../services/query/expenseNote/ExpenseNote.services';
import { createFilterModel } from './ExpenseNote.helper';

export default function ExpenseNote() {
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [rows, setRows] = useState<any[]>([]);
    const [rowCount, setRowCount] = useState<number>(0);
    const [open, setOpen] = React.useState({
        right: false,
    });
    const [orderNo, setOrderNo] = useState('');
    const [shipmentNo, setShipmentNo] = useState('');
    const [compassNo, setCompassNo] = useState('');
    const [startDate, setStartDate] = React.useState<string | null>(null);
    const [endDate, setEndDate] = React.useState<string | null>(null);
    const [status, setStatus]= React.useState<string | null>(null);
    const filterModels = createFilterModel(
        orderNo,
        shipmentNo,
        compassNo,
        startDate,
        endDate,
        status,
        setOrderNo,
        setShipmentNo,
        setCompassNo,
        setStartDate,
        setEndDate,
        setStatus,
    );
    const onDrawerOpen = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: true }));
    }, []);

    const onDrawerClose = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: false }));
    }, []);
    const ListExpenseNote = (payload: any) => {
        let req: any = {
            take: pageSize,
            page: pageNumber + 1,
            printStatus: false,
        };
        if (orderNo) req.orderNumber = orderNo;
        if (shipmentNo) req.shipmentNumber = shipmentNo;
        if (compassNo) req.documentNo = compassNo;
        if (startDate) req.startDate = payload.startDate;
        if (endDate) req.endDate = payload.endDate;
        if (status) req.printStatus = status;

        if (orderNo || shipmentNo || compassNo || startDate || endDate) {
            setPageNumber(0);
            req.page = 1;
            req.printStatus = null;
        }

        ExpenseNoteQuery.ListExpenseNote(req).then((response: any) => {
            setRows(response.data);
            setRowCount(response.count);
        });
    };
    return (
        <SCUIContent>
            <Box className={EXPNOTE.page}>
            <SCUIGeneralDrawer
                open={open['right']}
                anchor="right"
                width={'360px'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setOpen({ ...open, right: false });
                    }
                }}
            >
                <ExpenseNoteFilterDrawer
                    onClose={onDrawerClose}
                    getExpenseNote={ListExpenseNote}
                    filterModels={filterModels}
                />
            </SCUIGeneralDrawer>
            <Grid
                className={EXPNOTE.toolbarRow}
                display={'flex'}
                justifyContent={'flex-end'}
                size={{
                    xs: 12,
                    lg: 12,
                    md: 12,
                    xl: 12
                }}>
                <SCUIButton
                    className={EXPNOTE.inputButtonDetailedSearch}
                    text={'Detaylı Arama'}
                    sizeType="fixed"
                    type="primary"
                    size={'m'}
                    onClick={onDrawerOpen}
                >
                    <SearchIcon
                        fontSize={'large'}
                        sx={{ marginLeft: '1rem', marginBottom: '0.5rem' }}
                        style={{ color: 'white' }}
                    />
                </SCUIButton>
            </Grid>
            <Grid
                className={EXPNOTE.gridSection}
                size={{
                    xs: 12,
                    lg: 12,
                    md: 12,
                    xl: 12
                }}>
                <ExpenseNoteDataGrid
                    props={{
                        ListExpenseNote: ListExpenseNote,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        rows: rows,
                        rowCount: rowCount,
                        setPageNumber: setPageNumber,
                        setPageSize: setPageSize,
                        setRows: setRows,
                        setRowCount: setRowCount,
                    }}
                />
            </Grid>
            </Box>
        </SCUIContent>
    );
}
